module.exports = __webpack_public_path__ + "static/media/t-shirt.e1ee31e9.svg";